import { Review } from '../types'
import { mockVendors } from '../data/mockVendors'

interface ReviewCardProps {
  review: Review
}

export default function ReviewCard({ review }: ReviewCardProps) {
  const vendor = mockVendors.find(v => v.id === review.vendorId)
  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  return (
    <div className="review-card">
      <div className="review-header">
        <div className="review-info">
          <h3 className="review-title">{review.title}</h3>
          <div className="review-meta">
            <span className="reviewer-name">{review.userName}</span>
            {review.verified && <span className="verified-review">✓ Verified Purchase</span>}
            <span className="review-date">{formatDate(review.dateCreated)}</span>
          </div>
          {vendor && (
            <div className="vendor-link">
              Review for: <strong>{vendor.name}</strong>
            </div>
          )}
        </div>
        <div className="review-rating">
          <div className="rating-display">
            <span className="rating-value">{review.rating}/5</span>
          </div>
          <div className="recommend">
            {review.wouldRecommend ? (
              <span className="recommend-yes">👍 Recommends</span>
            ) : (
              <span className="recommend-no">👎 Doesn&apos;t Recommend</span>
            )}
          </div>
        </div>
      </div>

      <div className="review-content">
        <p>{review.content}</p>
      </div>

      {(review.pros.length > 0 || review.cons.length > 0) && (
        <div className="pros-cons">
          {review.pros.length > 0 && (
            <div className="pros">
              <h4>👍 Pros:</h4>
              <ul>
                {review.pros.map((pro, index) => (
                  <li key={index}>{pro}</li>
                ))}
              </ul>
            </div>
          )}
          {review.cons.length > 0 && (
            <div className="cons">
              <h4>👎 Cons:</h4>
              <ul>
                {review.cons.map((con, index) => (
                  <li key={index}>{con}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {review.productsPurchased.length > 0 && (
        <div className="products-purchased">
          <strong>Products purchased:</strong> {review.productsPurchased.join(', ')}
        </div>
      )}

      <div className="review-footer">
        <button className="helpful-btn">
          👍 Helpful ({review.helpfulVotes})
        </button>
        <button className="report-btn">
          🚩 Report
        </button>
      </div>
    </div>
  )
}